import React, { Component } from 'react';
import { Modal, Button, Icon, Header, Grid } from 'semantic-ui-react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { dateRegExp } from 'Common/SemanticWrapper';

class DateDialog extends Component {
  state = {
    value: null,
  };

  componentDidUpdate(prevProps) {
    if (!prevProps.open && this.props.open) {
      this.setState({ value: this.props.value });
    }
  }

  onChange = value => {
    this.setState({ value });
  };

  onComplete = () => {
    this.props.onChange(this.state.value);
    this.props.onComplete();
  };

  getSelected = () => {
    const { value } = this.state;

    if (!value) {
      return null;
    }

    if (typeof value === 'string' && dateRegExp.test(value)) {
      return moment(value, 'MM/DD/YYYY').toDate();
    } else {
      return moment(value).toDate();
    }
  };

  render() {
    const { open, title, buttonText, datePickerProps, onCancel } = this.props;

    return (
      <Modal closeIcon onClose={onCancel} open={open} size={'mini'}>
        <Header icon={'question circle'} content={title} />
        <Modal.Content>
          <Grid className={'date-dialog-grid--fixed-height'}>
            <Grid.Row>
              <Grid.Column textAlign={'center'}>
                <DatePicker
                  inline
                  showMonthDropdown
                  showYearDropdown
                  scrollableYearDropdown
                  {...datePickerProps}
                  dateFormat={'MM/DD/YYYY'}
                  onChange={this.onChange}
                  popoverAttachment={'bottom center'}
                  popoverTargetAttachment={'top center'}
                  selected={this.getSelected()}
                  todayButton={`Today: ${moment().format('MM/DD/YYYY')}`}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Modal.Content>
        <Modal.Actions>
          <Button primary onClick={this.onComplete}>
            <Icon className={'icon--white'} name="checkmark" /> {buttonText}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

export { DateDialog };



// WEBPACK FOOTER //
// ./src/pages/manageapplication/components/hub/DateDialog.js